import { push, replace } from 'connected-react-router';
import { put, takeLatest, select } from 'redux-saga/effects';

import { HIDE_MODAL } from '../actionCreators/uiActions';
import { SET_SHOW_ELEMENT_MODAL } from '../actionCreators/scribeActions';
import { getScribeLink } from '../shared/helpers/linkHelper';
import { ROUTE_CODES } from '../config/routes';

import { getScribeById } from './selectors';

function* hideModal({ scribeId }) {
  const currentHomeView = yield select(state => state.ui.currentHomeView);

  if (!scribeId && currentHomeView === 'templates') {
    yield put(replace('/'));
    return;
  } else if (!scribeId && currentHomeView === 'my-projects') {
    yield put(replace('/my-projects'));
    return;
  }

  const scribe = yield select(getScribeById, scribeId);
  yield put(replace(getScribeLink(scribe)));
}

function* showElementModal({ scribeId, elementType, elementId }) {
  const scribe = yield select(getScribeById, scribeId);

  if (elementType === 'upgrade') {
    yield put(push(getScribeLink(scribe, ROUTE_CODES.UPGRADE)));
    return;
  }

  const path = elementId ? ['edit', elementId] : ['add', elementType];
  yield put(push(getScribeLink(scribe, path)));
}

function* uiSagas() {
  yield takeLatest(HIDE_MODAL, hideModal);
  yield takeLatest(SET_SHOW_ELEMENT_MODAL, showElementModal);
}

export default uiSagas;
